'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { jsx as _jsx } from "react/jsx-runtime";
const withFormInfo = WrappedComponent => {
  class FormInfo extends Component {
    constructor(props) {
      super(props);
      this.updateFormInfo = data => {
        this.setState({
          formInfo: data
        });
      };
      this.clearFormInfo = () => {
        this.setState({
          formInfo: undefined
        });
      };
      this.fetchFormInfo = (guid, fetchFormInfoCallback = () => {}) => {
        this.props.fetchFormInfo(guid).then(data => {
          if (!data) {
            console.warn(`Could not fetch Form with guid: ${guid}`);
          }
          fetchFormInfoCallback(data);
          if (this.mounted) {
            this.updateFormInfo(data);
          }
        }).catch(error => {
          console.warn(error.message);
          fetchFormInfoCallback({
            error
          });
          if (this.mounted) {
            this.setState({
              formInfo: {
                error
              }
            });
          }
        });
      };
      this.mounted = false;
      this.state = {
        formInfo: undefined
      };
    }
    componentDidMount() {
      this.mounted = true;
      const {
        fetchOnMount,
        formGuid
      } = this.props;
      if (fetchOnMount && formGuid) {
        this.fetchFormInfo(formGuid);
      }
    }
    componentWillUnmount() {
      this.mounted = false;
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        fetchFormInfo: this.fetchFormInfo,
        updateFormInfo: this.updateFormInfo,
        clearFormInfo: this.clearFormInfo,
        formInfo: this.state.formInfo
      }));
    }
  }
  FormInfo.defaultProps = {
    fetchOnMount: false,
    formGuid: ''
  };
  FormInfo.displayName = `FormInfo(${getComponentName(WrappedComponent)})`;
  FormInfo.propTypes = {
    fetchFormInfo: PropTypes.func.isRequired,
    fetchOnMount: PropTypes.bool,
    formGuid: PropTypes.string
  };
  return FormInfo;
};
export default withFormInfo;